



































import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src/ValidationBoxWrapper.vue';
/**
 * `Footer` - Footer for OneWeb - Footer is the last module of the page. It contains links that help the user navigate through the website..
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-footer',
  components: {
    SlotContainer,
    ValidationBoxWrapper,
  },
});
